import { Grid, IconButton, Link, TextField, ToggleButtonGroup, Tooltip, useTheme } from "@mui/material"
import { CustomToggleButton } from "./StyledComponents"
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { useState } from "react";
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { XODO_DOCUMENTS_BASE_URL } from "./constants";

export default function VendorContractTemplates({contracts, templates, mode, onTrigger, onDelete, onCheck}) {
    return (
        <>
            {mode == "trigger" && <VendorTemplatesTriggerMode templates={templates} contracts={contracts} onTrigger={onTrigger} onDelete={onDelete}/>}
            {mode == "check" && <VendorTemplatesCheckMode templates={templates} contracts={contracts} onCheck={onCheck}/>}
        </>
    )
}

const VendorTemplatesTriggerMode = ({templates, contracts, onTrigger, onDelete}) => {
    const theme = useTheme()
    const lastContracts = getLastContractsHashMap(contracts)
    const [ sentContractSet, setSentContractSet ] = useState({})
    const handleSendContractButton = (template) => {
        setSentContractSet({...sentContractSet, [template]: true})
        onTrigger(template)
    }
    return (<>
        {templates.map((template, index) => {
            const matchingContract = lastContracts[template]
            const contractUrl = matchingContract && (matchingContract.file_url || (XODO_DOCUMENTS_BASE_URL + matchingContract.external_id))
            return <Grid key={index} container paddingBottom={1} justifyContent={"space-between"}>
                <Grid item md={10}>
                    <Grid container spacing={2}>
                        <Grid item md={6}>
                            <Grid container wrap="nowrap" alignItems={"center"} height={"100%"} padding={1} sx={{background: theme.palette.background.paper, borderRadius: 1}}>
                                <ArticleOutlinedIcon sx={{paddingRight: 1}}/>
                                {contractUrl ? 
                                <Link style={{textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}} target="_blank" href={contractUrl}>{template}</Link>:
                                <span style={{textWrap: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>{template}</span>}
                            </Grid>
                        </Grid>
                        <Grid item md={6} position={"relative"}>
                            <div style={{position: "absolute", color: "gray", fontSize: 10, top: 0}}>{index == 0 && <span>Expires</span>}</div>
                            <TextField
                                fullWidth
                                size="small"
                                disabled
                                value={matchingContract && matchingContract.expires_at}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                
                <Grid item>
                    <Grid container>
                        {matchingContract && 
                        <Grid item>
                            <Tooltip title={matchingContract.signed_at ? "the last sent contract was signed" : "pending signature"}>
                                <span>
                                    <IconButton sx={{pointerEvents: "none"}}>
                                        {matchingContract.signed_at ? <CheckCircleOutlineRoundedIcon color="success"/> : <HourglassEmptyRoundedIcon color="warning"/>}
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>}
                        <Grid item>
                            <Tooltip title={matchingContract && `last contract requested by ${matchingContract.requester_name || matchingContract.requester_email} at ${matchingContract.created_at}`}>
                                <span>
                                    <IconButton disabled={(template in sentContractSet)} onClick={() => handleSendContractButton(template)}>
                                        <SendOutlinedIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        })}
    </>)
}

const VendorTemplatesCheckMode = ({templates, onCheck}) => {
    const [ selectedTemplates, setSelectedTemplates ] = useState([])
    const handleToggleButtonChange = (event, val) => {
        console.log(val)
        setSelectedTemplates(val)
        onCheck && onCheck(val)
    }
    return (<>
        <ToggleButtonGroup
            style={{width: "100%"}}
            orientation="vertical"
            value={selectedTemplates}
            size="small"
            onChange={handleToggleButtonChange}
            color="primary"
        >
            {templates.map((template, index) =>         
                <CustomToggleButton 
                    key={index}
                    checked={selectedTemplates.includes(template)} 
                    value={template} 
                    icon={<ArticleOutlinedIcon />}
                />)
             }
        </ToggleButtonGroup>
    </>)
}

const getLastContractsHashMap = (contracts) => {
    const hashMap = {}
    contracts.forEach(contract=>{
        const contractIsMoreRecent = (contract.template_name in hashMap && hashMap[contract.template_name].created_at < contract.created_at)
        const contractTypeNotYetExist = !(contract.template_name in hashMap)
        if (contractIsMoreRecent || contractTypeNotYetExist) {
            hashMap[contract.template_name] = contract
        }
    })
    return hashMap
}